import { Bookmark } from 'lucide-react';
import { useWorkspaceStore } from '@/stores/workspace-store';
import type { SearchItem, SearchProvider } from '../types';
import type { SavedQuery, ConnectionConfig } from '@/types';

/**
 * Saved queries across every connection. Picking one opens it in a new
 * query tab (or focuses the existing tab if already open — the id is
 * derived from the saved-query id so duplicates collapse).
 */
export const savedQuerySearchProvider: SearchProvider = {
  id: 'saved-queries',
  kind: 'saved-query',
  list: (ctx) => {
    const queries = ctx.queryClient?.getQueryData<SavedQuery[]>(['saved-queries']) ?? [];
    const conns = ctx.queryClient?.getQueryData<ConnectionConfig[]>(['connections']) ?? [];
    const connName = (id: string) => conns.find((c) => c.id === id)?.name ?? id.slice(0, 8);

    return queries.map<SearchItem>((q) => {
      const snippet = q.sql.replace(/\s+/g, ' ').trim().slice(0, 60);
      return {
        id: `saved-query:${q.id}`,
        kind: 'saved-query',
        label: q.title,
        subtitle: `${connName(q.connectionId)} · ${snippet}${q.sql.length > 60 ? '…' : ''}`,
        icon: Bookmark,
        boost: 0.85,
        action: () => {
          useWorkspaceStore.getState().openTab({
            type: 'query',
            id: `saved-query:${q.id}`,
            connectionId: q.connectionId,
            title: q.title,
            sql: q.sql,
            savedQueryId: q.id,
          });
        },
      };
    });
  },
};
